module.exports = __webpack_public_path__ + "static/media/superscript.11695178.svg";